var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOvalRinginline = function SvgOvalRinginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 15 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#231F20",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    clipPath: "url(#OvalRing_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.774 19.489c3.67 0 6.646-4.11 6.646-9.18s-2.975-9.18-6.646-9.18-6.645 4.11-6.645 9.18 2.975 9.18 6.645 9.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.788 15.919c1.704 0 3.086-2.512 3.086-5.61s-1.382-5.61-3.086-5.61-3.086 2.511-3.086 5.61c0 3.098 1.382 5.61 3.086 5.61ZM7.774 1.129l.014 3.57M14.42 10.309l-3.48.007M4.698 10.309l-3.57.013M5.368 7.261 2.49 5.148M10.42 7.261l2.877-2.113M5.242 13.37l-2.877 2.113M10.294 13.37l2.877 2.113M7.768 15.919l.013 3.57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "OvalRing_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h15v20H0z"
  })))));
};
export default SvgOvalRinginline;